// @ts-nocheck
/* eslint-disable */
export const checkIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 3.23563L14.727 2L5.68821 11.4872L1.21644 7.19924L0 8.49165L5.74445 14L16 3.23563Z" fill="currentColor"/></svg>`,
    name: 'check' as const
};